import React from "react";
import { MessageCircle } from "lucide-react";

export const WhatsAppFab = () => {
  return (
    <a
      href="https://wa.me/917353626623?text=Hi%20NP%20Associates%2C%20I%20need%20help%20with%20"
      target="_blank"
      rel="noreferrer noopener"
      className="group fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center border border-foreground bg-primary text-primary-foreground shadow-lg transition hover:bg-foreground"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
    >
      <MessageCircle className="h-6 w-6" />
      <span className="absolute right-full mr-3 hidden whitespace-nowrap border border-foreground bg-background px-3 py-1.5 font-[Outfit] text-xs font-bold uppercase tracking-widest text-foreground group-hover:block">
        WhatsApp us
      </span>
    </a>
  );
};

export default WhatsAppFab;
